import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchdeleteethicsCounsellorDetails } from "./helpAndAssistantApi";
import swal from 'sweetalert';
export interface deleteethicsCounsellorDetailsState {
  deleteethicsCounsellorDetails: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: deleteethicsCounsellorDetailsState = {
  deleteethicsCounsellorDetails: [],
  status: "idle",
};

export const GetdeleteethicsCounsellorDetails = createAsyncThunk(
  "deleteethicsCounsellorDetails",
  async (data: any) => {
    const response = await fetchdeleteethicsCounsellorDetails(data);
    return response;
  }
);

export const DeleteethicsCounsellorDetailsSlice = createSlice({
  name: "deleteethicsCounsellorDetails",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetdeleteethicsCounsellorDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetdeleteethicsCounsellorDetails.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetdeleteethicsCounsellorDetails.fulfilled, (state, action) => {
        state.status = "success";
        state.deleteethicsCounsellorDetails = action.payload;
        //swal("Record saved success!",  "success");
      });
  },
});

export const {} = DeleteethicsCounsellorDetailsSlice.actions;

export const selectdeleteethicsCounsellorDetails = (state: RootState) => {
  return state.DeleteethicsCounsellorDetails.deleteethicsCounsellorDetails;
};

export default DeleteethicsCounsellorDetailsSlice.reducer;
